<template>
  <div class="login-page uk-position-center uk-overlay">
    <form autocomplete="off" novalidate class="auto-form-wrapper">
        <h3 class="title uk-margin-remove">Hello! let's get started</h3>
        <p class="uk-margin-remove uk-text-meta uk-text-small">Enter your details below.</p>
        <div class="uk-margin">
          <div class="uk-inline">
            <span class="uk-form-icon uk-icon" uk-icon="icon: user"></span>
            <input autocomplete="off" v-model="username" class="uk-input login-input" name="username" placeholder="username" type="text">
          </div>
        </div>
        <div class="uk-margin">
          <div class="uk-inline">
            <span class="uk-form-icon uk-icon" uk-icon="icon: unlock"></span>
            <input autocomplete="off" class="uk-input login-input" v-model="password" id="password" name="password" placeholder="password" type="password">
          </div>
        </div>
        <button class="uk-button uk-button-primary" type="button" @click="doLogin()" v-bind:disabled="isLoad">
          <span uk-spinner v-if="isLoad"></span>
          <span v-if="!isLoad">Login</span>
        </button>
        
        <div class="wrapper uk-text-meta uk-margin-top">
          <p class="footer-text uk-margin-remove">Copyright © 2018 resnetworld.com. All rights reserved.</p>
          <ul class="auth-footer text-gray">
            <li>
              <a href="#">Terms &amp; Conditions</a>
            </li>
            <li>
              <a href="#">Cookie Policy</a>
            </li>
          </ul>
        </div>
      </form>
  </div>
</template>

<script>
import axios from "axios";
import utility from "@/helpers/utility";
import { api } from "@/helpers/config";

export default {
  data: () => ({
    isLoad: false,
    username: "",
    password: ""
  }),
  created() {
    const el = document.body;
    el.classList.add("login");
  },
  methods: {
    async doLogin() {
      this.isLoad = true;
      try {
        var loginResponse = await axios.post(api.login, { email: this.username, password: this.password }
        );
        if (loginResponse.data.token) {
          localStorage.setItem("ResNetAppToken", loginResponse.data.token);
          localStorage.setItem("isAuth", true);
          localStorage.setItem("userId", loginResponse.data.user.id);
          this.$router.push({ name: "dashboard" });
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        this.isLoad = false;
        utility.notify("Auth Faild");
      }
    }
  }
};
</script>
